import { ParentMenuProps } from '@toasttab/shared/src/data/HeaderNavigation/MainNavigationMenu.d'

const RestaurantTypes: ParentMenuProps = {
  label: 'Restaurants',
  description: 'Toast solutions for any concept',
  heapClass: 'topnav_rx_v',
  showcaseMobile: true,
  showcaseEntries: [
    {
      title: 'Switching to Toast',
      description:
        'Feeling limited by your current tech? Toast is here for you, starting with easy onboarding.',
      heapClass: 'nav_switch_v',
      thumbnail:
        'https://d2w1ef2ao9g8r9.cloudfront.net/images/images/switching-to-toast-article-thumbnail.jpg',
      badge: {
        label: 'Featured',
        color: 'bg-yellow-25'
      },
      icon: 'before:content-icon-solutions-contactless',
      url: '/restaurant-pos/switch-to-toast'
    },
    {
      title: 'Open a New Restaurant',
      description:
        "We'll take care of the technology, so you can focus on what matters most.",
      heapClass: 'nav_nro_v',
      thumbnail:
        'https://d2w1ef2ao9g8r9.cloudfront.net/images/images/opening-a-new-restaurant-article-thumbnail.jpg',
      badge: {
        label: 'Featured',
        color: 'bg-yellow-25'
      },
      icon: 'before:content-icon-solutions-back-of-house',
      url: '/restaurant-pos/new-restaurant-opening'
    }
  ],
  subMenus: [
    {
      label: 'Service Models',
      showLabelMobile: false,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Quick Service',
          icon: 'before:content-icon-restaurant-types-quick-service',
          url: '/restaurant-pos/quick-service-pos-system',
          heapClass: 'nav_qsr_v'
        },
        {
          label: 'Full Service',
          icon: 'before:content-icon-restaurant-types-full-service',
          url: '/restaurant-pos/full-service-pos-system',
          heapClass: 'nav_fsr_v'
        },
        {
          label: 'Fast Casual',
          icon: 'before:content-icon-restaurant-types-fast-casual',
          url: '/restaurant-pos/fast-casual',
          heapClass: 'nav_fastcasual_v'
        },
        {
          label: 'Restaurant POS System',
          icon: 'before:content-icon-restaurant-types-restaurant-pos',
          url: '/restaurant-pos',
          heapClass: 'nav_restaurantposmain_v'
        }
      ]
    },
    {
      label: 'Restaurant Concepts',
      showLabelMobile: false,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Bar & Lounge',
          icon: 'before:content-icon-restaurant-types-bar-nightclub',
          url: '/restaurant-pos/bar-pos',
          heapClass: 'nav_bar_v'
        },
        {
          label: 'Casual Dining',
          icon: 'before:content-icon-restaurant-types-casual-dining',
          url: '/restaurant-pos/casual-dining',
          heapClass: 'nav_casual_v'
        },
        {
          label: 'Cafe & Bakery',
          icon: 'before:content-icon-restaurant-types-cafe-bakery',
          url: '/restaurant-pos/cafe-bakery',
          heapClass: 'nav_cafe_v'
        },
        {
          label: 'Fine Dining',
          icon: 'before:content-icon-restaurant-types-fine-dining',
          url: '/restaurant-pos/fine-dining',
          heapClass: 'nav_fine_v'
        },
        {
          label: 'Enterprise',
          icon: 'before:content-icon-restaurant-types-enterprise',
          url: '/restaurant-pos/enterprise',
          heapClass: 'nav_enterprise_v'
        },
        {
          label: 'Food Truck',
          icon: 'before:content-icon-restaurant-types-food-truck',
          url: '/restaurant-pos/food-truck',
          heapClass: 'nav_foodtruck_v'
        },
        {
          label: 'Pizza',
          icon: 'before:content-icon-restaurant-types-pizzeria',
          url: '/restaurant-pos/pizza-pos',
          heapClass: 'nav_pizza_v'
        },
        {
          label: 'Hotel Restaurant',
          icon: 'before:content-icon-restaurant-types-hotels',
          url: '/restaurant-pos/hotel-restaurant',
          heapClass: 'nav_hotel_v'
        },
        {
          label: 'Catering & Events',
          icon: 'before:content-icon-software-catering-events',
          url: '/products/catering-and-events',
          heapClass: 'nav_catering_v'
        }
      ]
    }
  ],
  sectionCTA: {
    title: 'Built for Restaurants',
    description:
      'Toast is designed for restaurant success. Customize Toast to fit the needs of your restaurant type.',
    url: '/restaurant-pos'
  }
}

export default RestaurantTypes
